import React from 'react';
import { useSelector } from 'react-redux';
import { selectAutoLoginFinished } from '@/store/selectors/autoLoginSelectors';
import { selectUserLoading } from '@/store/selectors/userSelectors';
import LoadingSpinner from '@/components/shared/spinner/LoadingSpinner';
import ControlsCenter from '@/pages/home/hero/thailand/ControlsCenter';
import FeaturedCenter from '@/pages/home/hero/thailand/FeaturedCenter';

const HomeHeroContentPrivateThailand = () => {
  const autoLoginFinished = useSelector(selectAutoLoginFinished);
  const userLoading = useSelector(selectUserLoading);
  if (!autoLoginFinished || userLoading) {
    return <LoadingSpinner />;
  }

  return (
    <div className="grid grid-cols-1 gap-8 justify-center items-center w-full p-4 py-36">
      <ControlsCenter />
      <div className="lg:absolute lg:left-8 md:bottom-8">
        <FeaturedCenter />
      </div>
    </div>
  );
};

export default HomeHeroContentPrivateThailand;
